module.exports = __webpack_public_path__ + "img/katabasis.13193596.png";